// src/components/Header.jsx
import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import './component.css';

function Header() {
    return (
        <AppBar position="static" elevation={0} className="appbar">
            <Container>
                <div className="header">
                    <Toolbar>
                        <Typography variant="h6" sx={{ flexGrow: 1 }}>
                            {/* <img
                                src="/img/darktm.png" // Replace with your logo URL
                                alt="Logo"
                                style={{ height: '50px', marginRight: 'auto' }} // Adjust height as needed
                            /> */}

                        </Typography>
                        {/* <Box sx={{ display: 'flex', gap: 1, position: 'absolute', right: '10px', top: '-30px' }}>
                            <Button color="inherit" variant="contained" className='nav-button login-in custom-button' >
                                Log In
                            </Button>
                            <Button color="inherit" variant="contained" className='nav-button Sign-up custom-button' >
                                Sign Up
                            </Button>
                        </Box> */}
                    </Toolbar>
                </div>
                <Box sx={{ display: 'flex', gap: 1, position: 'relative', marginBottom:"-20px", alignItems:"center",justifyContent:"center" }}>
                    <Typography variant='6' >
                        <img id="logo" height="100" src="/image/Actify365.png" alt="Actify360 logo"></img>
                    </Typography>
                </Box>


            </Container>
        </AppBar >
    );
}

export default Header;
